import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex flex-col items-center justify-center bg-[#F9F5EF] px-6 py-24 text-center overflow-hidden" data-id="element-113">
      {/* Decorative Botanical SVG - Top Left */}
      <motion.div initial={{
      opacity: 0,
      rotate: -10
    }} animate={{
      opacity: 0.6,
      rotate: 0
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute top-10 left-10 md:top-20 md:left-20 w-24 h-24 md:w-32 md:h-32 pointer-events-none opacity-60" data-id="element-114">
        <svg viewBox="0 0 100 100" fill="none" stroke="#8FAF88" strokeWidth="1" data-id="element-115">
          <path d="M50 100 C 50 100 20 60 20 30 C 20 10 40 0 50 10 C 60 0 80 10 80 30 C 80 60 50 100 50 100 Z" data-id="element-116" />
          <path d="M50 100 C 50 80 30 70 30 50" data-id="element-117" />
          <path d="M50 80 C 50 60 70 50 70 30" data-id="element-118" />
        </svg>
      </motion.div>

      <div className="max-w-3xl mx-auto z-10" data-id="element-119">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-8 flex flex-col items-center" data-id="element-120">
          <div className="w-12 h-[1px] bg-[#C4A882] opacity-50 mb-4" data-id="element-121"></div>
          <span className="text-xs uppercase tracking-[0.2em] text-[#8FAF88] font-medium" data-id="element-122">
            Sage Script
          </span>
        </motion.div>

        {/* Main Heading */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-5xl md:text-7xl lg:text-8xl font-light text-[#2C2C2C] leading-[1.1] mb-6" data-id="element-123">
          The Complete <br data-id="element-124" />
          <span className="italic" data-id="element-125">Wedding Planner</span>
        </motion.h1>

        {/* Subheading */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-xl md:text-2xl font-serif italic text-[#6B8F64] mb-8" data-id="element-126">
          A Refined Digital Planning System for Modern Brides
        </motion.p>

        {/* Body */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="text-lg text-[#2C2C2C] font-light max-w-lg mx-auto mb-12 leading-relaxed" data-id="element-127">
          Plan your wedding with clarity, structure, and calm confidence.
        </motion.p>

        {/* Product Image — now before details + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.0,
        delay: 1.0,
        ease: 'easeOut'
      }} className="flex justify-center mb-12" data-id="element-128">
          <motion.img src="https://cdn.magicpatterns.com/uploads/uyW4w1VeLCBPct8jQQKW3W/ChatGPT_Image_Feb_19,_2026,_08_08_53_PM.png" alt="The Complete Wedding Planner — digital cover on iPad" animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-64 md:w-80 lg:w-96 drop-shadow-2xl" data-id="element-129" />
        </motion.div>

        {/* Details */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 1.2
      }} className="text-sm text-[#8FAF88] uppercase tracking-widest mb-10 font-light" data-id="element-130">
          Designed for iPad use · Instant Download · Digital Product
        </motion.div>

        {/* CTA */}
        <motion.button initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 1.4
      }} whileHover={{
        scale: 1.02,
        backgroundColor: '#6B8F64'
      }} whileTap={{
        scale: 0.98
      }} className="bg-[#8FAF88] text-white px-10 py-4 text-sm uppercase tracking-[0.15em] hover:bg-[#6B8F64] transition-colors duration-300 shadow-sm" onClick={() => {
        const el = document.getElementById('pricing');
        if (el) el.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-131">
          Add to Cart
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 1.6
      }} className="mt-12 w-12 h-[1px] bg-[#C4A882] opacity-50 mx-auto" data-id="element-132"></motion.div>
      </div>
    </section>;
}